export const getDragAndDrop = (state) => {
  return state.dragAndDrop
}



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/drag-and-drop.js